module.exports = __webpack_public_path__ + "media/images/site/img_main-ed304f2c9c8982977cc2bcdb829f725d.png";